import { getDebugPanelEnv } from '@/features/debugPanel/client/getDebugPanelEnv';

import { type ApiConfig } from '../apiConfigTypes';
import { apiDevConfig } from '../apiDev.config';
import { apiProdConfig } from '../apiProd.config';
import { apiStageConfig } from '../apiStage.config';
import { getDefaultConfig } from '../getDefaultConfig';

export function getApiConfig(): ApiConfig {
  const env = getDebugPanelEnv();

  if (env) {
    switch (env) {
      case 'production':
        return apiProdConfig;
      case 'stage':
        return apiStageConfig;
      case 'dev':
        return apiDevConfig;
    }
  }

  return getDefaultConfig();
}
